import React, { useState, useEffect } from 'react';
import { IconsLAccent01 } from '../Icons/Icons_L';
import { Age } from '../Icons/CustomIcons';

const STORAGE_KEY = 'welcomeModalShown';

const WelcomeModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="map-logout-overlay" role="dialog" aria-modal="true" aria-labelledby="welcome-modal-title">
      <div className="map-logout-dialog">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
          <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <IconsLAccent01 size={84} />
            <Age size={28} color="#fff" style={{ position: 'absolute' }} />
          </div>
        </div>
        <h2 id="welcome-modal-title" className="map-logout-title">
          Willkommen bei Grosskinder Aktiv!
        </h2>
        <p className="map-logout-message">Nutze den <strong>Filter</strong>, um das Alter deiner Grosskinder anzugeben. Mit <strong>Login</strong> kannst du Ausflüge einreichen.</p>
        <button type="button" className="map-logout-confirm-btn" onClick={handleClose}>
          Los geht's!
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
